export default {
  headerName: 'Name',
  headerCode: 'Code',
  headerActions: 'Actions'
}
